// extracted by mini-css-extract-plugin
export var container = "_r3-0";
export var dotAnimation = "_r3-2";
export var dotsLoading = "_r3-1";